require('./mortgageRequestSimpleNoteAddressFormat.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const Immutable = require('immutable');
const classnames = require('classnames');

// @ components
const MortgageRequestFormattedAddress = require('components/mortgageRequest/mortgageRequestEstates/mortgageRequestEstatesData/mortgageRequestFormattedAddress/mortgageRequestFormattedAddress');

// @ commons
const { formatText } = require('core/i18n').i18n;

class MortgageRequestSimpleNoteAddressFormat extends React.Component {

    constructor(props) {
        super(props);

        this.buildAddressLabel = this.buildAddressLabel.bind(this);
        this.buildLivingPlaceLabel = this.buildLivingPlaceLabel.bind(this);
    }

    buildAddressLabel() {
        const { showAddressLabel } = this.props;

        return showAddressLabel && (
            <span className="mortgage-request-simple-note-address-format__label">
                {formatText('mortgageRequestSimpleNoteAddress-addressLabel')}
            </span>
        );
    }

    buildLivingPlaceLabel() {
        const { showLivingPlaceLabel, highlightLivingPlaceLabel, withSimpleNote } = this.props;

        const title = {
            livingSimple: formatText('mortgageRequestSimpleNoteAddress-titleLivingPlaceAndSimpleNote'),
            living: formatText('mortgageRequestSimpleNoteAddress-titleLivingPlace')
        };

        const livingPlaceClass = classnames('mortgage-request-simple-note-address-format__title', {
            'mortgage-request-simple-note-address-format__title--highlight': highlightLivingPlaceLabel
        });

        return showLivingPlaceLabel && (
            <span className={livingPlaceClass}>
                {(withSimpleNote) ? title.livingSimple : title.living}
            </span>
        );
    }

    render() {
        const { completeItem } = this.props;
        const addresLabel = this.buildAddressLabel();
        const livingPlaceLabel = this.buildLivingPlaceLabel();

        return (
            <div className="row mortgage-request-simple-note-address-format">
                <div className="col-xs-12">
                    {livingPlaceLabel}

                    {addresLabel}

                    <MortgageRequestFormattedAddress
                        immEstate={Immutable.fromJS(completeItem)}
                        className="mortgage-request-simple-note-address-format__item"
                        compact
                        v1
                    />
                </div>
            </div>
        )
    }
}

MortgageRequestSimpleNoteAddressFormat.propTypes = {
    withSimpleNote: PropTypes.bool,
    showLivingPlaceLabel: PropTypes.bool,
    highlightLivingPlaceLabel: PropTypes.bool,
    showAddressLabel: PropTypes.bool,
    completeItem: PropTypes.object.isRequired
};

MortgageRequestSimpleNoteAddressFormat.defaultProps = {
    withSimpleNote: false,
    showLivingPlaceLabel: true,
    highlightLivingPlaceLabel: true,
    showAddressLabel: false
};

module.exports = MortgageRequestSimpleNoteAddressFormat;
